// @flow
import styled, { keyframes } from "styled-components";

const show = keyframes`
  from {
    transform: rotateX(-60deg);
    opacity: 0;
  }

  to {
    transform: rotateX(0deg);
    opacity: 1;
  }
`;

const AnimationWrapper = styled.div`
  @media (min-width: 960px) {
    perspective: ${props => props.theme.perspective};
    backface-visibility: hidden;

    > div {
      transform-style: preserve-3d;
      transform-origin: 50% 0;
      animation: ${show} ${props => props.theme.showAnimation};
    }
  }
`;

export default AnimationWrapper;



// WEBPACK FOOTER //
// ./src/components/AnimationWrapper.js